import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  DaterangeModule,
  LoaderModule,
  NfFormsModule,
  SearchModule,
  ToggleModule,
} from '@northfork/ng-basics'
import { ActionErrorModalComponent } from './components/action-error-modal/action-error-modal.component'
import { CommandsComponent } from './components/commands/commands.component'
import { SystemCommandsComponent } from './components/commands/system-commands/system-commands.component'
import { ExceptionComponent } from './components/exceptions/exception.component'
import { JobsGridComponent } from './components/jobs-grid/jobs-grid.component'
import { JsonReaderModalComponent } from './components/json-reader-modal/json-reader-modal.component'
import { SelectSingleJobMessageComponent } from './components/select-single-job-message/select-single-job-message.component'
import { StatusComponent } from './components/status/status.component'
import { JobsPanelComponent } from './jobs-panel.component'
import { HttpJobsService } from './services/http-jobs.service'
import { JobsService } from './services/jobs.service'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    ReactiveFormsModule,
    NfFormsModule,
    FormsModule,
    DaterangeModule,
    ResizeHandleModule,
    GenericComponentsModule,
    NgbNavModule,
    LoaderModule,
    ToggleModule,
    SearchModule,
  ],
  declarations: [
    JobsPanelComponent,
    JobsGridComponent,
    CommandsComponent,
    ExceptionComponent,
    StatusComponent,
    SelectSingleJobMessageComponent,
    ActionErrorModalComponent,
    JsonReaderModalComponent,
    SystemCommandsComponent,
  ],
  exports: [JobsPanelComponent],
  providers: [{ provide: JobsService, useClass: HttpJobsService }],
})
export class JobsModule {}

export { JobsPanelComponent }
